import {Injectable} from '@angular/core';
import {APIProxy} from "../../../../common/http/services/api.proxy";
import {HttpObservable} from "../../../../common/http/services/http.wrapper";


@Injectable()
export class ThemeChangerProxy{

	constructor(private apiHttp:APIProxy) {
	}

	public getUserTheme(): HttpObservable<any> {
		return this.apiHttp.get("UserContext", "GetUserTheme");
	}
}
